export default {
  methods: {
    sportMatchCount(sprtId, market) {
      var sprtEvents = market == this.$store.getters.market.inPlayMarket.key ? this.$store.getters.sportInPlayEvents : this.$store.getters.sportAllEvents
      if(sprtEvents) {
        if(sprtId.indexOf('G') >= 0){
          if(sprtId == 'G1') {
            var bk = sprtEvents[2] ? sprtEvents[2] : 0
            var amft = sprtEvents[13] ? sprtEvents[13] : 0
            return bk + amft
          } else if (sprtId == 'G2') {
            var crk = sprtEvents[7] ? sprtEvents[7] : 0
            var ichk = sprtEvents[14] ? sprtEvents[14] : 0
            var hb = sprtEvents[19] ? sprtEvents[19] : 0
            var esp = sprtEvents[20] ? sprtEvents[20] : 0
            return crk + ichk + hb + esp
          } else {
            return 0
          }
        } else {
          return sprtEvents[sprtId.slice(1)] ? sprtEvents[sprtId.slice(1)] : 0
        }
      } else {
        return 0
      }
    },
    resetSportBettype() {
      //this.$store.commit('SELECTED_SPORT', this.$store.getters.sportList[0])
      this.$store.commit('BETTYPELIST',
        _.filter(
          this.$store.getters.sportBettypeList,
          {
            'sprtId' : this.$store.getters.selectedSport.sprtId
          }
        )
      )
      this.$store.commit('SELECTED_BETTYPE',  _.cloneDeep(this.$store.getters.bettypeList[0]))
    },
  },
}



// WEBPACK FOOTER //
// ./resources/wob/vue/mixins/sportMatchCount.js